<template>
  <v-flex class="tables-layout">
    <table-layout>
      <template v-slot:title>
        팀 실적 (합계)
      </template>
      <template v-slot:table>
        <v-data-table
          class="data-table-layout"
          :headers="getHeader(teamSumHeader)"
          :items="teamSumList"
          :items-per-page="-1"
          :loading="loading"
          no-data-text="조회된 데이터가 없습니다"
          hide-default-footer
          mobile-breakpoint="md"
        >
          <template v-slot:item.cnt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.loanAmount="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.feeTotal="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
          <template v-slot:item.incentiveAmt="{ value }">
            <div>{{ inputComma(value) }}</div>
          </template>
        </v-data-table>
      </template>
    </table-layout>
    <v-row>
      <v-col>
        <table-layout>
          <template v-slot:title>
            팀 실적 (팀원별)
          </template>
          <template v-slot:button>
          </template>
          <template v-slot:table>
            <v-data-table
                class="data-table-layout"
                :headers="getHeader(teamMemberHeader)"
                :items="userList"
                no-data-text="조회된 데이터가 없습니다"
                :items-per-page="-1"
                :loading="loading"
                hide-default-footer fixed-header
                mobile-breakpoint="md"
                @click:row="showMemberDetail"
            >
              <template v-slot:item.cnt="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.loanAmount="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.feeTotal="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.incentiveAmt="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
            </v-data-table>
          </template>
          <template v-slot:popup>
            <member-performance-detail
              :is-show="isShowDetail"
              :params-data="paramsData"
              :row-data="rowData"
              @close="isShowDetail = false"
            />
          </template>
        </table-layout>
      </v-col>
      <v-col>
        <table-layout>
          <template v-slot:title>
            팀 실적 (상품별)
          </template>
          <template v-slot:table>
            <v-data-table
                fixed-header
                class="data-table-layout"
                :headers="getHeader(teamProductHeader)"
                :items="productList"
                no-data-text="조회된 데이터가 없습니다"
                :items-per-page="-1"
                :loading="loading"
                hide-default-footer
                mobile-breakpoint="md"
            >
              <template v-slot:item.cnt="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.loanAmount="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
              <template v-slot:item.feeTotal="{ value }">
                <div>{{ inputComma(value) }}</div>
              </template>
            </v-data-table>
          </template>
        </table-layout>
      </v-col>
    </v-row>
  </v-flex>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import {
  LOAN_PERFORMANCE_TEAM_MEMBER_TABLE,
  LOAN_PERFORMANCE_TEAM_PRODUCT_TABLE,
  LOAN_PERFORMANCE_TEAM_SUM_TABLE
} from "@/util/TableHeaders";
import TableMixin from "@/mixin/TableMixin";
import _ from "lodash";
import MemberPerformanceDetail from "@/pages/Loan/popup/LoanPerformanceTeam/MemberPerformanceDetail.vue";

export default {
  name: "LoanPerformanceTeamDetail",
  components: {MemberPerformanceDetail, TableLayout},
  props: ["paramsData", "data", "loading"],
  mixins: [TableMixin],
  data() {
    return {
      teamSumHeader: LOAN_PERFORMANCE_TEAM_SUM_TABLE,
      teamMemberHeader: LOAN_PERFORMANCE_TEAM_MEMBER_TABLE,
      teamProductHeader: LOAN_PERFORMANCE_TEAM_PRODUCT_TABLE,
      teamSumList: [],
      productList: [],
      userList: [],
      isShowDetail: false,
      rowData: {}
    }
  },
  watch: {
    data(value) {
      if (!_.isEmpty(value)) {
        this.teamSumList = [_.cloneDeep(value.pormanceSum)];
        this.productList = _.cloneDeep(value.performanceSumByProductList);
        const userDataList = _.cloneDeep(value.performanceSumByUserList);
        console.log(userDataList);
        this.userList = userDataList.map(item => ({
          ...item,
          rank: item.rank === 0 ? "-" : item.rank
        }));
      }
    },
  },
  methods: {
    showMemberDetail(data) {
      this.isShowDetail = true;
      this.rowData = data;
    }
  }
}
</script>

<style lang="scss" scoped>
.tables-layout {
  height: 65vh;
  max-height: 800px;
  overflow-y: auto;
  .data-table-layout {
    padding: 20px 10px;
    border: 1px solid #222;
  }
}
</style>